<template>
  <div id="app">
    <div class="container-fluid">
      <!-- Search box and results -->
      <div class="row mt-3 px-3 px-lg-5">
        <div class="col-12">
          <p class="intro">
            Syötä hakukenttään haluamasi osa ja katso kuuluuko se turvan piiriin.
          </p>
        </div>
        <div class="col-12 col-md-8 col-lg-6 col-xl-4 mt-2 p-0">
          <form v-on:submit.prevent="search" class="col-12">
            <div class="input-group" @click="closeAll()">
              <input
                aria-label="Syötä hakukenttään haluamasi osa ja katso kuuluuko se turvan piiriin."
                autocomplete="off"
                type="name"
                v-model="searchString"
                class="form-control rounded-start"
                id="searchbox-input"
                placeholder=""
                @input="filterParts"
              />
              <span class="input-group-addon rounded-end" style="background-color: #f0f0f0 !important">
                <span
                  v-if="!searchString"
                  class="d-flex align-self-center icon-search ms-1 mt-1 me-0"
                  style="color:#8B8C90;font-size:1.5rem;"
                ></span>
                <span
                  v-else
                  @click="clearSearch()"
                  class="d-flex align-self-center icon-plus clear-icon ms-1 mt-1 me-0"
                  style="color:#8B8C90;font-size:1.5rem;"
                ></span>
              </span>
            </div>
          </form>
        </div>
        <div v-if="filteredParts.length && searchString" class="search-results my-3 mx-md-0">
          <div
            v-for="(filteredPart, idx) in filteredParts"
            :key="idx"
            class="col px-md-2 pt-1 pb-2 search-results-items"
          >
            <div class="d-inline-flex align-items-center badge bg-light text-dark mb-1 px-md-1">
              <span :class="`${filteredPart.icon} small-icon pe-1`"></span>
              <h6 class="support-text">{{ filteredPart.title }}</h6>
            </div>
            <div class="d-flex">
              <span class="icon-shield pe-2"></span>
              <h5 class="book-font">{{ filteredPart.header }}</h5>
            </div>
            <div>
              <p class="support-text" style="padding-left: 2rem;">
                {{ filteredPart.content }}
              </p>
            </div>
          </div>
        </div>
        <div v-if="!filteredParts.length && searchString" class="my-3 mx-md-0">
          <p><strong>Ei hakutuloksia.</strong></p>
          <p>
            Tarkista vielä, voisiko etsimäsi osa löytyä jollain toisella sanalla. On myös mahdollista, että etsimäsi osa
            ei kuulu Toyota Relax -turvan piiriin. Lisätietoja Toyota Relax -turvasta saat valtuutetulta korjaamolta.
          </p>
        </div>
      </div>
      <!-- Toyota Relax included parts title 
      <div class="row mt-2 px-3 px-lg-5">
        <div class="col-12">
          <h3>Toyota Relax turvaan kuuluvat kohteet</h3>
        </div>
      </div>

      -->
      <!-- Parts loop -->
      <div id="parts-toggle" class="row mt-2 mb-3 g-0 px-3 px-lg-5">
        <div v-for="(section, idx) in sections" :key="idx" class="col-12 col-md-6 col-lg-4 parts-section">
          <button
            class="toggler w-100 px-2 py-3 border rounded"
            data-bs-toggle="collapse"
            :data-bs-target="`#${formatTitle(section.title)}`"
            aria-expanded="false"
            @click="toggleCollapse()"
          >
            <div class="d-flex align-items-center justify-content-between">
              <div class="d-flex align-items-center">
                <span :class="`${section.icon} pe-2`"></span>
                <h5>{{ section.title }}</h5>
              </div>
              <div class="d-flex">
                <span class="icon-plus" @click="clearSearch()"></span>
              </div>
            </div>
          </button>
        </div>
        <div
          v-for="section in sections"
          :key="section.title"
          class="collapse collapse-body collapse-section py-2"
          :id="`${formatTitle(section.title)}`"
          data-bs-parent="#parts-toggle"
        >
          <div class="row px-3 px-lg-5 m-0">
            <div class="col-12 p-0 pb-1">
              <div class="d-flex align-items-center justify-content-between">
                <div class="d-flex align-items-center">
                  <h3>{{ section.title }}</h3>
                </div>
                <div class="d-flex">
                  <button
                    type="button"
                    class="close-btn"
                    data-bs-toggle="collapse"
                    :data-bs-target="`#${formatTitle(section.title)}`"
                  >
                    <span class="book-font">Sulje</span>
                    <span class="close-icon">&times;</span>
                  </button>
                </div>
              </div>
            </div>
            <div class="parts-grid my-2 px-0">
              <div
                v-for="part in section.parts"
                :key="part.header"
                class="col px-1 px-md-2 py-1 py-lg-2 parts-grid-items"
              >
                <div class="d-flex">
                  <span class="icon-shield pe-2"></span>
                  <h5 class="book-font header-title">{{ part.header }}</h5>
                </div>
                <div>
                  <p class="support-text" style="padding-left: 2rem;">
                    {{ part.content }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "App",
  data: () => ({
    searchString: "",
    filteredParts: [],
    sections: [
      {
        title: "Moottori",
        icon: "icon-engine",
        parts: [
          {
            title: "Moottori",
            icon: "icon-engine",
            header: "Apulaitteiden käyttöakseli",
            content: "",
          },
          {
            title: "Moottori",
            icon: "icon-engine",
            header: "Happianturi",
            content: "",
          },
          {
            title: "Moottori",
            icon: "icon-engine",
            header: "Hukkaportti",
            content: "",
          },
          {
            title: "Moottori",
            icon: "icon-engine",
            header: "Jakohihnan ohjainrulla",
            content: "",
          },
          {
            title: "Moottori",
            icon: "icon-engine",
            header: "Jakohihnat",
            content: "",
          },
          {
            title: "Moottori",
            icon: "icon-engine",
            header: "Jakohihnojen kiristimet",
            content: "",
          },
          {
            title: "Moottori",
            icon: "icon-engine",
            header: "Jakoketju",
            content: "",
          },
          {
            title: "Moottori",
            icon: "icon-engine",
            header: "Jakoketjun hammaspyörät",
            content: "",
          },
          {
            title: "Moottori",
            icon: "icon-engine",
            header: "Kaapelit (muut kuin sähköjohdot)",
            content: "",
          },
          {
            title: "Moottori",
            icon: "icon-engine",
            header: "Kampiakseli ja -laakerit",
            content: "",
          },
          {
            title: "Moottori",
            icon: "icon-engine",
            header: "Kampiakselin hihnapyörä",
            content: "",
          },
          {
            title: "Moottori",
            icon: "icon-engine",
            header: "Keinuvivut",
            content: "",
          },
          {
            title: "Moottori",
            icon: "icon-engine",
            header: "Kiertokanki",
            content: "",
          },
          {
            title: "Moottori",
            icon: "icon-engine",
            header: "Männänlaakerit ja holkit",
            content: "",
          },
          {
            title: "Moottori",
            icon: "icon-engine",
            header: "Männät ja männänrenkaat",
            content: "",
          },
          {
            title: "Moottori",
            icon: "icon-engine",
            header: "Nakutusanturi",
            content: "",
          },
          {
            title: "Moottori",
            icon: "icon-engine",
            header: "Nokka-akseli",
            content: "",
          },
          {
            title: "Moottori",
            icon: "icon-engine",
            header: "Ohjainrulla",
            content: "",
          },
          {
            title: "Moottori",
            icon: "icon-engine",
            header: "Pakokaasun kierrätysventtiili (EGR)",
            content: "",
          },
          {
            title: "Moottori",
            icon: "icon-engine",
            header: "Starttikehä",
            content: "",
          },
          {
            title: "Moottori",
            icon: "icon-engine",
            header: "Sylinterikannen tiivisteet",
            content: "",
          },
          {
            title: "Moottori",
            icon: "icon-engine",
            header: "Sylinterilohko",
            content: "",
          },
          {
            title: "Moottori",
            icon: "icon-engine",
            header: "Sylinterinkansi",
            content: "",
          },
          {
            title: "Moottori",
            icon: "icon-engine",
            header: "Tasapainoakseli",
            content: "",
          },
          {
            title: "Moottori",
            icon: "icon-engine",
            header: "Tiivisteet ja tiivisterenkaat",
            content: "",
          },
          {
            title: "Moottori",
            icon: "icon-engine",
            header: "Tunnistimet (ml. rengaspainetunnistin, NOx)",
            content: "",
          },
          {
            title: "Moottori",
            icon: "icon-engine",
            header: "Turboahdin",
            content: "",
          },
          {
            title: "Moottori",
            icon: "icon-engine",
            header: "Turboahtimen välijäähdytin",
            content: "",
          },
          {
            title: "Moottori",
            icon: "icon-engine",
            header: "Valvematic-toimilaite",
            content: "",
          },
          {
            title: "Moottori",
            icon: "icon-engine",
            header: "Vauhtipyörä",
            content: "",
          },
          {
            title: "Moottori",
            icon: "icon-engine",
            header: "Venttiilikopan kansi ja tiivisteet",
            content: "",
          },
          {
            title: "Moottori",
            icon: "icon-engine",
            header: "Venttiilin nostin",
            content: "",
          },
          {
            title: "Moottori",
            icon: "icon-engine",
            header: "Venttiilit ja ohjaimet",
            content: "",
          },
          {
            title: "Moottori",
            icon: "icon-engine",
            header: "Vesipumppu",
            content: "",
          },
          {
            title: "Moottori",
            icon: "icon-engine",
            header: "Vetolevy",
            content: "",
          },
          {
            title: "Moottori",
            icon: "icon-engine",
            header: "Öljyn lauhdutin",
            content: "",
          },
          {
            title: "Moottori",
            icon: "icon-engine",
            header: "Öljynpainekatkaisija",
            content: "",
          },
          {
            title: "Moottori",
            icon: "icon-engine",
            header: "Öljynsuodattimen jalka",
            content: "",
          },
          {
            title: "Moottori",
            icon: "icon-engine",
            header: "Öljypohja",
            content: "",
          },
          {
            title: "Moottori",
            icon: "icon-engine",
            header: "Öljypumppu",
            content: "",
          },
        ],
      },
      {
        title: "Polttoainejärjestelmä (Bensiini)",
        icon: "icon-gas-station",
        parts: [
          {
            title: "Polttoainejärjestelmä (Bensiini)",
            icon: "icon-gas-station",
            header: "Elektroninen polttoaineen ruiskutusjärjestelmä",
            content: "",
          },
          {
            title: "Polttoainejärjestelmä (Bensiini)",
            icon: "icon-gas-station",
            header: "Ilmamäärämittari",
            content: "",
          },
          {
            title: "Polttoainejärjestelmä (Bensiini)",
            icon: "icon-gas-station",
            header: "Kaasuläppä kotelo",
            content: "",
          },
          {
            title: "Polttoainejärjestelmä (Bensiini)",
            icon: "icon-gas-station",
            header: "Moottorin ohjausyksikkö (ECU)",
            content: "",
          },
          {
            title: "Polttoainejärjestelmä (Bensiini)",
            icon: "icon-gas-station",
            header: "Polttoaineen paineensäädin",
            content: "",
          },
          {
            title: "Polttoainejärjestelmä (Bensiini)",
            icon: "icon-gas-station",
            header: "Polttoainejärjestelmän anturit",
            content: "",
          },
          {
            title: "Polttoainejärjestelmä (Bensiini)",
            icon: "icon-gas-station",
            header: "Polttoainemittari",
            content: "",
          },
          {
            title: "Polttoainejärjestelmä (Bensiini)",
            icon: "icon-gas-station",
            header: "Polttoainepumppu",
            content: "",
          },
          {
            title: "Polttoainejärjestelmä (Bensiini)",
            icon: "icon-gas-station",
            header: "Polttoainesuuttimet ja tiivisteet",
            content: "",
          },
          {
            title: "Polttoainejärjestelmä (Bensiini)",
            icon: "icon-gas-station",
            header: "Polttoainetankki",
            content: "",
          },
          {
            title: "Polttoainejärjestelmä (Bensiini)",
            icon: "icon-gas-station",
            header: "Sähköinen polttoainepumppu",
            content: "",
          },
          {
            title: "Polttoainejärjestelmä (Bensiini)",
            icon: "icon-gas-station",
            header: "Tankkivaruste",
            content: "",
          },
        ],
      },
      {
        title: "Hybridikomponentit",
        icon: "icon-flash",
        parts: [
          {
            title: "Hybridikomponentit",
            icon: "icon-flash",
            header: "HUOM! HSD-ajoakku kuuluu Hybridiakkuturvaan (10 vuotta / 350 000 km)",
            content: "",
          },
          {
            title: "Hybridikomponentit",
            icon: "icon-flash",
            header: "Hybridi invertteri/konvertteri paketti",
            content: "(kun yli 5v. / 100 000 km tehdastakuun)",
          },
          {
            title: "Hybridikomponentit",
            icon: "icon-flash",
            header: "Hybridiakun ohjausyksikkö",
            content: "(kun yli 5v. / 100 000 km tehdastakuun)",
          },
          {
            title: "Hybridikomponentit",
            icon: "icon-flash",
            header: "Hybridiohjausyksikkö (ECU)",
            content: "(kun yli 5v. / 100 000 km tehdastakuun)",
          },
        ],
      },
      {
        title: "Polttoainejärjestelmä (Diesel)",
        icon: "icon-gas-station",
        parts: [
          {
            title: "Polttoainejärjestelmä (Diesel)",
            icon: "icon-gas-station",
            header: "AdBlue -säiliö, suutin, pumppu, urea-putket ja johtosarja",
            content: "",
          },
          {
            title: "Polttoainejärjestelmä (Diesel)",
            icon: "icon-gas-station",
            header: "Hehkutulpat",
            content: "",
          },
          {
            title: "Polttoainejärjestelmä (Diesel)",
            icon: "icon-gas-station",
            header: "Ilmamäärämittari",
            content: "",
          },
          {
            title: "Polttoainejärjestelmä (Diesel)",
            icon: "icon-gas-station",
            header: "Kaasuläpän asentotunnistin",
            content: "",
          },
          {
            title: "Polttoainejärjestelmä (Diesel)",
            icon: "icon-gas-station",
            header: "Korkeapainepumppu",
            content: "",
          },
          {
            title: "Polttoainejärjestelmä (Diesel)",
            icon: "icon-gas-station",
            header: "Moottorin ohjausyksikkö (ECU)",
            content: "",
          },
          {
            title: "Polttoainejärjestelmä (Diesel)",
            icon: "icon-gas-station",
            header: "Polttoainepumppu",
            content: "",
          },
          {
            title: "Polttoainejärjestelmä (Diesel)",
            icon: "icon-gas-station",
            header: "Polttoainesuuttimet ja tiivisteet",
            content: "",
          },
          {
            title: "Polttoainejärjestelmä (Diesel)",
            icon: "icon-gas-station",
            header: "Polttoainetankki",
            content: "",
          },
          {
            title: "Polttoainejärjestelmä (Diesel)",
            icon: "icon-gas-station",
            header: "Tankkivaruste",
            content: "",
          },
        ],
      },
      {
        title: "Jäähdytysjärjestelmä",
        icon: "icon-snowflake",
        parts: [
          {
            title: "Jäähdytysjärjestelmä",
            icon: "icon-snowflake",
            header: "Jäähdytin",
            content: "",
          },
          {
            title: "Jäähdytysjärjestelmä",
            icon: "icon-snowflake",
            header: "Jäähdyttimen korkki",
            content: "",
          },
          {
            title: "Jäähdytysjärjestelmä",
            icon: "icon-snowflake",
            header: "Jäähdytysnesteen tasoanturi",
            content: "",
          },
          {
            title: "Jäähdytysjärjestelmä",
            icon: "icon-snowflake",
            header: "Moottorin jäähdytysnesteen lämpötilan kytkin tai anturi",
            content: "",
          },
          {
            title: "Jäähdytysjärjestelmä",
            icon: "icon-snowflake",
            header: "Moottorin tuuletin",
            content: "",
          },
          {
            title: "Jäähdytysjärjestelmä",
            icon: "icon-snowflake",
            header: "Termostaatti ja kotelo",
            content: "",
          },
          {
            title: "Jäähdytysjärjestelmä",
            icon: "icon-snowflake",
            header: "Tuulettimen anturi",
            content: "",
          },
          {
            title: "Jäähdytysjärjestelmä",
            icon: "icon-snowflake",
            header: "Tuulettimen rele",
            content: "",
          },
          {
            title: "Jäähdytysjärjestelmä",
            icon: "icon-snowflake",
            header: "Vesipumppu",
            content: "",
          },
          {
            title: "Jäähdytysjärjestelmä",
            icon: "icon-snowflake",
            header: "Viskokytkin",
            content: "",
          },
        ],
      },
      {
        title: "Manuaalivaihteisto",
        icon: "icon-transmission",
        parts: [
          {
            title: "Manuaalivaihteisto",
            icon: "icon-transmission",
            header: "Hammaspyörät ja akselit",
            content: "",
          },
          {
            title: "Manuaalivaihteisto",
            icon: "icon-transmission",
            header: "Kytkentäholkki",
            content: "",
          },
          {
            title: "Manuaalivaihteisto",
            icon: "icon-transmission",
            header: "Kytkin vaijeri",
            content: "",
          },
          {
            title: "Manuaalivaihteisto",
            icon: "icon-transmission",
            header: "Kytkinhaarukka ja nivel",
            content: "",
          },
          {
            title: "Manuaalivaihteisto",
            icon: "icon-transmission",
            header: "Laakerit ja holkit",
            content: "",
          },
          {
            title: "Manuaalivaihteisto",
            icon: "icon-transmission",
            header: "Pääsylinteri",
            content: "",
          },
          {
            title: "Manuaalivaihteisto",
            icon: "icon-transmission",
            header: "Synkronointi renkaat",
            content: "",
          },
          {
            title: "Manuaalivaihteisto",
            icon: "icon-transmission",
            header: "Tiivisteet ja stefat",
            content: "",
          },
          {
            title: "Manuaalivaihteisto",
            icon: "icon-transmission",
            header: "Työsylinteri",
            content: "",
          },
          {
            title: "Manuaalivaihteisto",
            icon: "icon-transmission",
            header: "Vaihdevipu",
            content: "",
          },
          {
            title: "Manuaalivaihteisto",
            icon: "icon-transmission",
            header: "Vaihdevivusto ja vaijerit",
            content: "",
          },
          {
            title: "Manuaalivaihteisto",
            icon: "icon-transmission",
            header: "Vaihteisto / vaihteistokotelo",
            content: "",
          },
        ],
      },
      {
        title: "Automaattivaihteisto",
        icon: "icon-transmission",
        parts: [
          {
            title: "Automaattivaihteisto",
            icon: "icon-transmission",
            header: "Elektroninen ohjausyksikkö",
            content: "",
          },
          {
            title: "Automaattivaihteisto",
            icon: "icon-transmission",
            header: "Elektroniset toimilaitteet",
            content: "",
          },
          {
            title: "Automaattivaihteisto",
            icon: "icon-transmission",
            header: "Hammaspyörät ja akselit",
            content: "",
          },
          {
            title: "Automaattivaihteisto",
            icon: "icon-transmission",
            header: "Jarruhihnat",
            content: "",
          },
          {
            title: "Automaattivaihteisto",
            icon: "icon-transmission",
            header: "Kytkimet",
            content: "",
          },
          {
            title: "Automaattivaihteisto",
            icon: "icon-transmission",
            header: "Laakerit ja holkit",
            content: "",
          },
          {
            title: "Automaattivaihteisto",
            icon: "icon-transmission",
            header: "Momentinmuunnin",
            content: "",
          },
          {
            title: "Automaattivaihteisto",
            icon: "icon-transmission",
            header: "Navat/ Kytkentäholkki",
            content: "",
          },
          {
            title: "Automaattivaihteisto",
            icon: "icon-transmission",
            header: "Tiivisteet ja stefat",
            content: "",
          },
          {
            title: "Automaattivaihteisto",
            icon: "icon-transmission",
            header: "Vaihdevipu",
            content: "",
          },
          {
            title: "Automaattivaihteisto",
            icon: "icon-transmission",
            header: "Vaihdevivusto ja johdot",
            content: "",
          },
          {
            title: "Automaattivaihteisto",
            icon: "icon-transmission",
            header: "Vaihteen valitsin",
            content: "",
          },
          {
            title: "Automaattivaihteisto",
            icon: "icon-transmission",
            header: "Vaihteisto- / vaihteistokotelo",
            content: "",
          },
          {
            title: "Automaattivaihteisto",
            icon: "icon-transmission",
            header: "Venttiilistö",
            content: "",
          },
          {
            title: "Automaattivaihteisto",
            icon: "icon-transmission",
            header: "Öljyjäähdytin",
            content: "",
          },
          {
            title: "Automaattivaihteisto",
            icon: "icon-transmission",
            header: "Öljypumppu",
            content: "",
          },
        ],
      },
      {
        title: "Jakovaihteisto ja tasauspyörästö",
        icon: "icon-engine",
        parts: [
          {
            title: "Vetopyörästöt",
            icon: "icon-engine",
            header: "Akselit",
            content: "",
          },
          {
            title: "Vetopyörästöt",
            icon: "icon-engine",
            header: "Hammasrattaat",
            content: "",
          },
          {
            title: "Vetopyörästöt",
            icon: "icon-engine",
            header: "Holkit",
            content: "",
          },
          {
            title: "Vetopyörästöt",
            icon: "icon-engine",
            header: "Keskitasauspyörästö",
            content: "",
          },
          {
            title: "Vetopyörästöt",
            icon: "icon-engine",
            header: "Laakerit",
            content: "",
          },
          {
            title: "Vetopyörästöt",
            icon: "icon-engine",
            header: "Tasauspyörästö siirtovivusto",
            content: "",
          },
          {
            title: "Vetopyörästöt",
            icon: "icon-engine",
            header: "Tasauspyörästön kartio- ja siirtohammaspyörä",
            content: "",
          },
          {
            title: "Vetopyörästöt",
            icon: "icon-engine",
            header: "Tasauspyörästön kotelo",
            content: "",
          },
          {
            title: "Vetopyörästöt",
            icon: "icon-engine",
            header: "Tasauspyörästön navat",
            content: "",
          },
        ],
      },
      {
        title: "Voimansiirto",
        icon: "icon-engine",
        parts: [
          {
            title: "Voimansiirto",
            icon: "icon-engine",
            header: "Holkit",
            content: "",
          },
          {
            title: "Voimansiirto",
            icon: "icon-engine",
            header: "Kardaaniakseli",
            content: "",
          },
          {
            title: "Voimansiirto",
            icon: "icon-engine",
            header: "Kumisuojukset (enintään 185 000 km, esim. pallonivelen kumi)",
            content: "",
          },
          {
            title: "Voimansiirto",
            icon: "icon-engine",
            header: "Kytkentälaitteet",
            content: "",
          },
          {
            title: "Voimansiirto",
            icon: "icon-engine",
            header: "Laakerit",
            content: "",
          },
          {
            title: "Voimansiirto",
            icon: "icon-engine",
            header: "Nivelakselit (kardaani)",
            content: "",
          },
          {
            title: "Voimansiirto",
            icon: "icon-engine",
            header: "Tiivisteet ja stefat",
            content: "",
          },
          {
            title: "Voimansiirto",
            icon: "icon-engine",
            header: "Vetoakselit",
            content: "",
          },
          {
            title: "Voimansiirto",
            icon: "icon-engine",
            header: "Vetonivel",
            content: "",
          },
        ],
      },
      {
        title: "Jousitus",
        icon: "icon-rims",
        parts: [
          {
            title: "Jousitus",
            icon: "icon-rims",
            header: "Apurunko",
            content: "",
          },
          {
            title: "Jousitus",
            icon: "icon-rims",
            header: "Etu- ja takajouset",
            content: "",
          },
          {
            title: "Jousitus",
            icon: "icon-rims",
            header: "Lukkomutterit",
            content: "",
          },
          {
            title: "Jousitus",
            icon: "icon-rims",
            header: "Navat",
            content: "",
          },
          {
            title: "Jousitus",
            icon: "icon-rims",
            header: "Olka-akseli",
            content: "",
          },
          {
            title: "Jousitus",
            icon: "icon-rims",
            header: "Poikittais- ja runkopalkki",
            content: "",
          },
          {
            title: "Jousitus",
            icon: "icon-rims",
            header: "Pyöränlaakerit (enintään 185 000 km)",
            content: "",
          },
          {
            title: "Jousitus",
            icon: "icon-rims",
            header: "Raidetangonpää",
            content: "",
          },
          {
            title: "Jousitus",
            icon: "icon-rims",
            header: "Välilevyt",
            content: "",
          },
          {
            title: "Jousitus",
            icon: "icon-rims",
            header: "Vääntösauvat",
            content: "",
          },
        ],
      },
      {
        title: "Ohjaus",
        icon: "icon-steering-wheel",
        parts: [
          {
            title: "Ohjaus",
            icon: "icon-steering-wheel",
            header: "Hammastanko",
            content: "",
          },
          {
            title: "Ohjaus",
            icon: "icon-steering-wheel",
            header: "Laakerit",
            content: "",
          },
          {
            title: "Ohjaus",
            icon: "icon-steering-wheel",
            header: "Nivelet",
            content: "",
          },
          {
            title: "Ohjaus",
            icon: "icon-steering-wheel",
            header: "Ohjauspylväs",
            content: "",
          },
          {
            title: "Ohjaus",
            icon: "icon-steering-wheel",
            header: "Ohjaussimpukka",
            content: "",
          },
          {
            title: "Ohjaus",
            icon: "icon-steering-wheel",
            header: "Ohjaustehostimen pumppu",
            content: "",
          },
          {
            title: "Ohjaus",
            icon: "icon-steering-wheel",
            header: "Ohjaustehostimen öljysäiliö",
            content: "",
          },
          {
            title: "Ohjaus",
            icon: "icon-steering-wheel",
            header: "Ohjausvaihde",
            content: "",
          },
          {
            title: "Ohjaus",
            icon: "icon-steering-wheel",
            header: "Ohjausvaihteen runko",
            content: "",
          },
          {
            title: "Ohjaus",
            icon: "icon-steering-wheel",
            header: "Ohjausvarsi",
            content: "",
          },
          {
            title: "Ohjaus",
            icon: "icon-steering-wheel",
            header: "Ohjausvivusto",
            content: "",
          },
          {
            title: "Ohjaus",
            icon: "icon-steering-wheel",
            header: "Raidetangot",
            content: "",
          },
          {
            title: "Ohjaus",
            icon: "icon-steering-wheel",
            header: "Tiivisteet",
            content: "",
          },
        ],
      },
      {
        title: "Jarrut",
        icon: "icon-rims",
        parts: [
          {
            title: "Jarrut",
            icon: "icon-rims",
            header: "ABS -komponentit",
            content: "",
          },
          {
            title: "Jarrut",
            icon: "icon-rims",
            header: "ABS -ohjausyksikkö",
            content: "",
          },
          {
            title: "Jarrut",
            icon: "icon-rims",
            header: "Alipainepumppu",
            content: "",
          },
          {
            title: "Jarrut",
            icon: "icon-rims",
            header: "Jarrunestesäiliö",
            content: "",
          },
          {
            title: "Jarrut",
            icon: "icon-rims",
            header: "Jarruputket",
            content: "",
          },
          {
            title: "Jarrut",
            icon: "icon-rims",
            header: "Jarrupääsylinteri",
            content: "",
          },
          {
            title: "Jarrut",
            icon: "icon-rims",
            header: "Jarrurummut",
            content: "",
          },
          {
            title: "Jarrut",
            icon: "icon-rims",
            header: "Jarrusatulat",
            content: "",
          },
          {
            title: "Jarrut",
            icon: "icon-rims",
            header: "Jarrutehostin",
            content: "",
          },
          {
            title: "Jarrut",
            icon: "icon-rims",
            header: "Nopeusanturit",
            content: "",
          },
          {
            title: "Jarrut",
            icon: "icon-rims",
            header: "Paineensäätöventtiilit",
            content: "",
          },
          {
            title: "Jarrut",
            icon: "icon-rims",
            header: "Seisontajarrun sähköinen toimilaite",
            content: "",
          },
          {
            title: "Jarrut",
            icon: "icon-rims",
            header: "Työsylinterit",
            content: "",
          },
          {
            title: "Jarrut",
            icon: "icon-rims",
            header: "Vivusto",
            content: "",
          },
        ],
      },
      {
        title: "Ilmastointi / lämmitys",
        icon: "icon-air-conditioning",
        parts: [
          {
            title: "Ilmastointi / lämmitys",
            icon: "icon-air-conditioning",
            header: "Höyrystimen lämpötila -anturi",
            content: "",
          },
          {
            title: "Ilmastointi / lämmitys",
            icon: "icon-air-conditioning",
            header: "Höyrystin",
            content: "",
          },
          {
            title: "Ilmastointi / lämmitys",
            icon: "icon-air-conditioning",
            header: "Kompressori",
            content: "",
          },
          {
            title: "Ilmastointi / lämmitys",
            icon: "icon-air-conditioning",
            header: "Kuivain",
            content: "",
          },
          {
            title: "Ilmastointi / lämmitys",
            icon: "icon-air-conditioning",
            header: "Lauhdutin",
            content: "",
          },
          {
            title: "Ilmastointi / lämmitys",
            icon: "icon-air-conditioning",
            header: "Lämmityslaitteen kenno",
            content: "",
          },
          {
            title: "Ilmastointi / lämmitys",
            icon: "icon-air-conditioning",
            header: "Lämmönsäätöläpät ja -moottorit",
            content: "",
          },
          {
            title: "Ilmastointi / lämmitys",
            icon: "icon-air-conditioning",
            header: "Lämmönsäätövivusto",
            content: "",
          },
          {
            title: "Ilmastointi / lämmitys",
            icon: "icon-air-conditioning",
            header: "Paisuntaventtiili",
            content: "",
          },
          {
            title: "Ilmastointi / lämmitys",
            icon: "icon-air-conditioning",
            header: "Polttoainetoiminen lisälämmitin",
            content: "",
          },
          {
            title: "Ilmastointi / lämmitys",
            icon: "icon-air-conditioning",
            header: "Puhaltimen moottori",
            content: "",
          },
        ],
      },
      {
        title: "Sähköjärjestelmä",
        icon: "icon-battery",
        parts: [
          {
            title: "Sähköjärjestelmä",
            icon: "icon-battery",
            header: "Ajovalojen säätömoottorit",
            content: "",
          },
          {
            title: "Sähköjärjestelmä",
            icon: "icon-battery",
            header: "Anturit",
            content: "",
          },
          {
            title: "Sähköjärjestelmä",
            icon: "icon-battery",
            header: "Audio ja Navibox",
            content: "",
          },
          {
            title: "Sähköjärjestelmä",
            icon: "icon-battery",
            header: "ECU: n ja ohjelmiston uudelleenohjelmointi vianpoistossa (paitsi DTC -poisto)",
            content: "",
          },
          {
            title: "Sähköjärjestelmä",
            icon: "icon-battery",
            header: "Elektroninen sytytysyksikkö",
            content: "",
          },
          {
            title: "Sähköjärjestelmä",
            icon: "icon-battery",
            header: "Ikkunamoottorit/säätimet",
            content: "",
          },
          {
            title: "Sähköjärjestelmä",
            icon: "icon-battery",
            header: "Istuinten lämmitysvastukset",
            content: "",
          },
          {
            title: "Sähköjärjestelmä",
            icon: "icon-battery",
            header: "Johtosarjat",
            content: "",
          },
          {
            title: "Sähköjärjestelmä",
            icon: "icon-battery",
            header: "Kaiuttimet",
            content: "",
          },
          {
            title: "Sähköjärjestelmä",
            icon: "icon-battery",
            header: "Katvevahtiyksikkö (BSM)",
            content: "",
          },
          {
            title: "Sähköjärjestelmä",
            icon: "icon-battery",
            header: "Kauko-ohjaimet avaimissa",
            content: "",
          },
          {
            title: "Sähköjärjestelmä",
            icon: "icon-battery",
            header: "Kellot",
            content: "",
          },
          {
            title: "Sähköjärjestelmä",
            icon: "icon-battery",
            header: "Keskuslukitussolenoidit",
            content: "",
          },
          {
            title: "Sähköjärjestelmä",
            icon: "icon-battery",
            header: "Keskuslukon ohjausyksikkö",
            content: "",
          },
          {
            title: "Sähköjärjestelmä",
            icon: "icon-battery",
            header: "Keyless-entry tunnistin (ulkokahva - jos tunnistin ei ole erillinen)",
            content: "",
          },
          {
            title: "Sähköjärjestelmä",
            icon: "icon-battery",
            header: "Kierroslukumittari",
            content: "",
          },
          {
            title: "Sähköjärjestelmä",
            icon: "icon-battery",
            header: "Käynnistysmoottori",
            content: "",
          },
          {
            title: "Sähköjärjestelmä",
            icon: "icon-battery",
            header: "Laturi",
            content: "",
          },
          {
            title: "Sähköjärjestelmä",
            icon: "icon-battery",
            header: "Lämmitetyt elementit",
            content: "",
          },
          {
            title: "Sähköjärjestelmä",
            icon: "icon-battery",
            header: "Lämmityslaitteen puhallin",
            content: "",
          },
          {
            title: "Sähköjärjestelmä",
            icon: "icon-battery",
            header: "Mittarit",
            content: "",
          },
          {
            title: "Sähköjärjestelmä",
            icon: "icon-battery",
            header: "Nopeusmittari ja nopeusanturi",
            content: "",
          },
          {
            title: "Sähköjärjestelmä",
            icon: "icon-battery",
            header: "Peilimoottorit",
            content: "",
          },
          {
            title: "Sähköjärjestelmä",
            icon: "icon-battery",
            header: "Pesimen moottorit",
            content: "",
          },
          {
            title: "Sähköjärjestelmä",
            icon: "icon-battery",
            header: "Puolat",
            content: "",
          },
          {
            title: "Sähköjärjestelmä",
            icon: "icon-battery",
            header: "Pyyhkijän moottorit",
            content: "",
          },
          {
            title: "Sähköjärjestelmä",
            icon: "icon-battery",
            header: "Ratin lämmitys - sähkövika (Ratti)",
            content: "",
          },
          {
            title: "Sähköjärjestelmä",
            icon: "icon-battery",
            header: "Releet (ml. SMR)",
            content: "",
          },
          {
            title: "Sähköjärjestelmä",
            icon: "icon-battery",
            header: "Savukkeensytyttimet",
            content: "",
          },
          {
            title: "Sähköjärjestelmä",
            icon: "icon-battery",
            header: "Sisävalon viiveyksikkö",
            content: "",
          },
          {
            title: "Sähköjärjestelmä",
            icon: "icon-battery",
            header: "Spiraalikaapeli",
            content: "",
          },
          {
            title: "Sähköjärjestelmä",
            icon: "icon-battery",
            header: "Sytytysjohdot",
            content: "",
          },
          {
            title: "Sähköjärjestelmä",
            icon: "icon-battery",
            header: "Sähköikkunakytkin",
            content: "",
          },
          {
            title: "Sähköjärjestelmä",
            icon: "icon-battery",
            header: "Sähköiset istuimen moottorit",
            content: "",
          },
          {
            title: "Sähköjärjestelmä",
            icon: "icon-battery",
            header: "Turvatyynyanturit",
            content: "",
          },
          {
            title: "Sähköjärjestelmä",
            icon: "icon-battery",
            header: "Tuulilasin lämmitys - sähkövika (Tuulilasi)",
            content: "",
          },
          {
            title: "Sähköjärjestelmä",
            icon: "icon-battery",
            header: "Vahvistin",
            content: "",
          },
          {
            title: "Sähköjärjestelmä",
            icon: "icon-battery",
            header: "Varashälytin (vain alkuperäinen Toyota)",
            content: "",
          },
          {
            title: "Sähköjärjestelmä",
            icon: "icon-battery",
            header: "Vilkkurele",
            content: "",
          },
          {
            title: "Sähköjärjestelmä",
            icon: "icon-battery",
            header: "Äänitorvi: Käsikäyttöiset kytkimet",
            content: "",
          },
        ],
      },
      {
        title: "Kori",
        icon: "icon-door",
        parts: [
          {
            title: "Kori",
            icon: "icon-door",
            header: "Kattoluukku (vain alkuperäinen Toyota)",
            content: "",
          },
          {
            title: "Kori",
            icon: "icon-door",
            header: "Kattoluukun moottorit (vain alkuperäinen Toyota)",
            content: "",
          },
          {
            title: "Kori",
            icon: "icon-door",
            header: "Konepellin avausvaijeri",
            content: "",
          },
          {
            title: "Kori",
            icon: "icon-door",
            header: "Ovilukot",
            content: "",
          },
          {
            title: "Kori",
            icon: "icon-door",
            header: "Penkin rungot",
            content: "",
          },
          {
            title: "Kori",
            icon: "icon-door",
            header: "Peruutuskamera",
            content: "",
          },
          {
            title: "Kori",
            icon: "icon-door",
            header: "Pyyhkimen vivusto",
            content: "",
          },
          {
            title: "Kori",
            icon: "icon-door",
            header: "Takaluukun kaasujousi",
            content: "",
          },
          {
            title: "Kori",
            icon: "icon-door",
            header:
              "Tehtaalla asennetut lisävarusteet ja HUB asenteiset lisävarusteet, jos löytyy takuujärjestelmään kirjattu.",
            content: "",
          },
          {
            title: "Kori",
            icon: "icon-door",
            header: "Turvavyön mekanismi",
            content: "",
          },
        ],
      },
      {
        title: "Vetykomponentit (polttokenno)",
        icon: "icon-flash",
        parts: [
          {
            title: "Vetykomponentit (polttokenno)",
            icon: "icon-flash",
            header: "DC-DC muunnin",
            content: "",
          },
          {
            title: "Vetykomponentit (polttokenno)",
            icon: "icon-flash",
            header: "Polttokennon H2 -säiliöt",
            content: "",
          },
          {
            title: "Vetykomponentit (polttokenno)",
            icon: "icon-flash",
            header: "Polttokenno ilmakompressori",
            content: "",
          },
          {
            title: "Vetykomponentit (polttokenno)",
            icon: "icon-flash",
            header: "Polttokenno PCU (Power Control Unit) ja polttokennot.",
            content: "",
          },
        ],
      },
      {
        title: "EV-komponentit",
        icon: "icon-flash",
        parts: [
          {
            title: "EV-komponentit",
            icon: "icon-flash",
            header: "Ajomoottori ja invertteri/konvertteri paketti",
            content: "",
          },
        ],
      },
    ],
  }),
  methods: {
    toggleCollapse() {
      this.clearSearch()
      this.getCollapseHeight()
    },
    formatTitle(title) {
      let accents = "ÄÅäåÖö"
      let accentsOut = "AAaaOo"
      title = title.split("")
      title.forEach((letter, index) => {
        let i = accents.indexOf(letter)
        if (i != -1) {
          title[index] = accentsOut[i]
        }
      })
      return title
        .join("")
        .replace(/\s+/g, "-")
        .replace(/\(|\)/g, "")
        .replace(/\//g, "ja")
        .toLowerCase()
    },
    filterParts() {
      if (this.searchString.length < 1) {
        this.filteredParts = []
      }

      const allParts = []

      this.sections.forEach(function(section) {
        section.parts.forEach(function(part) {
          allParts.push(part)
        })
      })

      this.filteredParts = allParts.filter((part) => {
        return part.header.toLowerCase().includes(this.searchString.toLowerCase())
      })
    },
    clearSearch() {
      this.searchString = ""
      this.filteredParts = []
    },
    closeAll() {
      let relaxContainer = document.querySelector("#parts-toggle")
      let resetButton = document.querySelectorAll(".parts-section button")
      let allElements = document.querySelectorAll(".collapse-section")
      for (let a = 0; a < allElements.length; a++) {
        allElements[a].classList.remove("show")
      }
      for (let i = 0; i < resetButton.length; i++) {
        resetButton[i].setAttribute("aria-expanded", "false")
      }
      relaxContainer.style["min-height"] = "auto"
    },
    getCollapseHeight() {
      let laatikko = document.querySelectorAll(".collapse-section")
      let relaxContainer = document.querySelector("#parts-toggle")
      let laatikkoKorkeus = Number

      for (let a = 0; a < laatikko.length; a++) {
        laatikko[a].style.position = "relative"
        if (laatikko[a].scrollHeight > 0) {
          laatikkoKorkeus = laatikko[a].scrollHeight + laatikko[a].offsetTop / 2
        }
        laatikko[a].style.position = "absolute"
      }
      relaxContainer.style["min-height"] = `${laatikkoKorkeus}px`
    },
  },
  components: {},
}
</script>

<style>
#app {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  overflow-x: hidden;
}

#parts-toggle {
  align-content: flex-start !important;
}

.container-fluid {
  padding: 0 !important;
}

.parts-section {
  position: relative;
  padding: 0.4rem;
}

button.toggler {
  border: none;
  background: none;
  outline: none;
  padding: 0;
  margin: 0;
  text-align: left;
}

.close-btn {
  outline: none;
  box-shadow: none;
  border: none;
  background: transparent;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  padding: 0;
  margin: 0;
  height: 20px;
}

.close-icon {
  color: #8b8c90;
  font-size: 2rem;
  margin-left: 10px;
}

/* Icons */

.icon-plus {
  font-size: 1.5rem;
  color: #8b8c90;
  transition: transform 0.3s ease-in-out;
}

span[class*="icon-"]:not(.icon-plus) {
  width: 32px;
  height: auto;
}

.icon-shield::before {
  content: url("./assets/shield.svg");
}

.icon-air-conditioning::before {
  content: url("./assets/air-conditioning.svg");
}

.icon-battery::before {
  content: url("./assets/battery.svg");
}

.icon-consumption::before {
  content: url("./assets/consumption.svg");
}

.icon-door::before {
  content: url("./assets/door.svg");
}

.icon-engine::before {
  content: url("./assets/engine.svg");
}

.icon-flash::before {
  content: url("./assets/flash.svg");
}

.icon-gas-station::before {
  content: url("./assets/gas-station.svg");
}

.icon-power::before {
  content: url("./assets/power.svg");
}

.icon-rims::before {
  content: url("./assets/rims.svg");
}

.icon-safety::before {
  content: url("./assets/safety.svg");
}

.icon-snowflake::before {
  content: url("./assets/snowflake.svg");
}

.icon-steering-wheel::before {
  content: url("./assets/steering-wheel.svg");
}

.icon-temperature::before {
  content: url("./assets/temperature.svg");
}

.icon-transmission::before {
  content: url("./assets/transmission.svg");
}

.icon-wind::before {
  content: url("./assets/wind.svg");
}

.parts-section button[aria-expanded="false"] .icon-plus {
  transform: rotate(0deg);
}

.parts-section button[aria-expanded="true"] .icon-plus {
  transform: rotate(45deg);
}

.clear-icon.icon-plus {
  transition: none;
  padding-right: 8px;
  padding-left: 0px;
}

.clear-icon.icon-plus:hover {
  cursor: pointer;
}

.clear-icon.icon-plus::before {
  transition: none;
  font-size: 1.5rem;
  color: red;
  transform: rotate(45deg);
}

.small-icon {
  width: 20px !important;
  filter: brightness(0) saturate(100%);
}

.collapse-body {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 999;
  width: 100%;
  background-color: #f6f6f6;
}

#parts-toggle {
  position: relative;
}

.parts-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 1px;
}

.search-results {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 1px;
  min-width: 100vw;
  margin-left: -32px;
}
@media screen and (max-width: 767.98px) {
  .search-results .search-results-items {
    padding-left: 6px !important;
    padding-right: 6px !important;
  }
}
@media screen and (min-width: 768px) {
  .search-results {
    grid-template-columns: repeat(3, 1fr);
    min-width: 100%;
    margin-left: inherit;
  }
  .parts-grid {
    grid-template-columns: repeat(3, 1fr);
  }
}

.search-results-items,
.parts-grid-items {
  outline: 1px solid #d6d6d6;
}

/* Stupid hack for collapsing  */

@media screen and (max-width: 767.99px) {
  #moottori {
    top: 140px;
  }
  #polttoainejarjestelma-bensiini {
    top: calc(2 * 135px);
  }
  #hybridikomponentit {
    top: calc(3 * 136px);
  }
  #polttoainejarjestelma-diesel {
    top: calc(4 * 135px);
  }
  #jaahdytysjarjestelma {
    top: calc(5 * 135px);
  }
  #manuaalivaihteisto {
    top: calc(6 * 135px);
  }
  #automaattivaihteisto {
    top: calc(7 * 135px);
  }
  #jakovaihteisto-ja-tasauspyorasto {
    top: calc(8 * 135px);
  }
  #voimansiirto {
    top: calc(9 * 135px);
  }
  #jousitus {
    top: calc(10 * 135px);
  }
  #ohjaus {
    top: calc(11 * 135.4px);
  }
  #jarrut {
    top: calc(12 * 135.4px);
  }
  #ilmastointi-ja-lammitys {
    top: calc(13 * 135.4px);
  }
  #sahkojarjestelma {
    top: calc(14 * 135.4px);
  }
  #kori {
    top: calc(15 * 135.4px);
  }
  #vetykomponentit-polttokenno {
    top: calc(16 * 135.5px);
  }
  #ev-komponentit {
    top: calc(17 * 135.5px);
  }
}
@media screen and (min-width: 768px) and (max-width: 991.99px) {
  #moottori,
  #polttoainejarjestelma-bensiini {
    top: 135px;
  }
  #hybridikomponentit,
  #polttoainejarjestelma-diesel {
    top: calc(2 * 135px);
  }
  #jaahdytysjarjestelma,
  #manuaalivaihteisto {
    top: calc(3 * 135px);
  }
  #automaattivaihteisto,
  #jakovaihteisto-ja-tasauspyorasto {
    top: calc(4 * 135px);
  }
  #voimansiirto,
  #jousitus {
    top: calc(5 * 135px);
  }
  #ohjaus,
  #jarrut {
    top: calc(6 * 135px);
  }
  #ilmastointi-ja-lammitys,
  #sahkojarjestelma {
    top: calc(7 * 135px);
  }
  #kori,
  #vetykomponentit-polttokenno {
    top: calc(8 * 136px);
  }
  #ev-komponentit {
    top: calc(9 * 136px);
  }
}
@media screen and (min-width: 992px) {
  #moottori,
  #polttoainejarjestelma-bensiini,
  #hybridikomponentit {
    top: 140px;
  }
  #polttoainejarjestelma-diesel,
  #jaahdytysjarjestelma,
  #manuaalivaihteisto {
    top: 270px;
  }
  #automaattivaihteisto,
  #jakovaihteisto-ja-tasauspyorasto,
  #voimansiirto {
    top: 410px;
  }
  #jousitus,
  #ohjaus,
  #jarrut {
    top: 540px;
  }
  #ilmastointi-ja-lammitys,
  #sahkojarjestelma,
  #kori {
    top: 680px;
  }
  #vetykomponentit-polttokenno,
  #ev-komponentit {
    top: 820px;
  }
}
</style>
